import { apiFetch } from '../lib/api';
import type { LureTypeResponse } from '../types/api';

export function listLureTypes(): Promise<LureTypeResponse[]> {
  return apiFetch<LureTypeResponse[]>('/api/luretypes');
}
